var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "link"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.828 10.1717C13.0778 9.42179 12.0606 9.00053 11 9.00053C9.9393 9.00053 8.92207 9.42179 8.17196 10.1717L4.17196 14.1717C3.78992 14.5407 3.48519 14.982 3.27555 15.4701C3.06592 15.9581 2.95557 16.483 2.95096 17.0141C2.94634 17.5452 3.04755 18.0719 3.24867 18.5635C3.4498 19.0551 3.74681 19.5017 4.12238 19.8773C4.49795 20.2528 4.94456 20.5498 5.43614 20.751C5.92773 20.9521 6.45445 21.0533 6.98556 21.0487C7.51668 21.0441 8.04156 20.9337 8.52958 20.7241C9.01759 20.5144 9.45897 20.2097 9.82796 19.8277L10.93 18.7267M10.172 13.8277C10.9221 14.5776 11.9393 14.9988 13 14.9988C14.0606 14.9988 15.0778 14.5776 15.828 13.8277L19.828 9.82768C20.5566 9.07327 20.9598 8.06286 20.9507 7.01407C20.9415 5.96528 20.5209 4.96203 19.7792 4.2204C19.0376 3.47877 18.0344 3.05809 16.9856 3.04898C15.9368 3.03987 14.9264 3.44304 14.172 4.17168L13.072 5.27168",
    stroke: "#212121",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.254c7a47a785e37dac49fc4aab4b0da7.svg";
export { ForwardRef as ReactComponent };